define('drops/richTextEditor/richTextEditor',[
    'jquery',
    'when',
    'lq/drop',
    'lq/uploader',
    'lq/style',
    'lq',
    'lq/required'
], function ($, when, Drop, Uploader, Style, lq, Required) {
    'use strict';

    var tinymce = null;

    var tenantUrlPlaceholder = '{{{TenantUrl}}}';

    var vKey = 86,
        xKey = 88;

    var defaults = {
        data: {
            readonly: false,
            undoRedoEnabled: true,
            boldEnabled: true,
            italicEnabled: true,
            underlineEnabled: true,
            stripFormattingOnPaste: true,
            spellcheckerEnabled: false,
            strikethroughEnabled: false,
            formatselectEnabled: false,
            removeformatEnabled: false,
            fullscreenEnabled: false,
            previewEnabled: false,
            printEnabled: false,
            anchorEnabled: false,
            cutEnabled: false,
            copyEnabled: false,
            pasteEnabled: false,
            selectallEnabled: false,
            searchreplaceEnabled: false,
            superscriptEnabled: false,
            subscriptEnabled: false,
            lineheightEnabled: false,
            wordcountEnabled: false,
            runtimeResizeEnabled: false,
            size: {
                x: 400,
                y: 250
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function RichTextEditor(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;
        this.$element
            .addClass('boxToBorderSize rich-text-editor')
            .css({
                whiteSpace: 'pre-wrap'
            })
            .attr('tabindex', this.data.tabIndex)
            .on('focus', function() {
                self.focus();
            });
        this.elementId = _.uniqueId('rte_');
        this.initialUpdate = null;

        this.$textarea = $('<textarea id="' + this.elementId + '" />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        Style.renderStyles(this);

        this.triggerChangedEvent = _.debounce(this.triggerEventIfEnabled.bind(this, 'changed'), 200);
    };

    Drop.extend(RichTextEditor, Drop);

    RichTextEditor.typeName = 'RichTextEditor';

    RichTextEditor.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();

        var deferred = when.defer();
        require([
                'tinymce'
            ],
            function(lazyLoadedTinymce) {
                tinymce = lazyLoadedTinymce;
                deferred.resolve();
            });

        return deferred.promise;
    };

    RichTextEditor.prototype.postRender = function () {
        this.createRichTextEditor();
    };

    RichTextEditor.prototype.createRichTextEditor = function () {
        this.toolbar = this.buildToolbar();

        if (this.toolbar)
            this.$element.addClass('with-toolbar');

        var self = this;

        var configuration = {
            body_class: this.getCssClassNameForStyling(),
            elements: this.elementId,
            mode: 'exact',
            width: '100%',
            height: '100%',
            menubar: false,
            statusbar: this.data.runtimeResizeEnabled,
            plugins: this.buildPluginsList(),
            toolbar: this.toolbar ? this.toolbar : false,
            paste_as_text: this.data.stripFormattingOnPaste,
            relative_urls: false,
            remove_script_host: false,
            readonly: this.data.readonly,
            browser_spellcheck: this.data.spellcheckerEnabled,
            file_browser_callback: this.openFileBrowser.bind(this),
            cache_suffix: require_config.urlArgs(null, ''),
            setup: function(ed) {
                if (self.isEventEnabled('changed')) {
                    ed.on('change', self.contentChanged.bind(self));
                    ed.on('keyup', self.contentChanged.bind(self));
                }

                ed.on('init', function() {
                    self.editor = ed;

                    if (self.initialUpdate) {
                        self.setValue(self.initialUpdate);
                        self.initialUpdate = null;
                    }
                });

                if (self.data.disableParagraphs) {
                    ed.on('keydown', function (event) {
                        if (event.keyCode !== 13 || !event.shiftKey)
                            return true;
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    });
                }

                if (self.data.hasMaxLength) {
                    var allowedKeys = [8, 35, 36, 37, 38, 39, 40, 46];

                    ed.on('keydown', function(e) {
                        if (allowedKeys.indexOf(e.keyCode) !== -1)
                            return true;

                        if (self.getLengthOfContent() + 1 <= self.data.maxLength)
                            return true;

                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    });
                }
            },
            formats: {
                bold: { inline: 'b' },
                italic: { inline: 'i' },
                underline: { inline: 'u' }
            },
            extended_valid_elements: 'b,i,u',
            content_css: lq.getTenantUrl('StyleSheet/Get?v=' + lq.getStylesVersion()),
            urlconverter_callback: function(url, node, on_save, name) {
                // note: replace with placeholder only for images. Other links are beyond our control.
                return node === 'img' ? url.replace(lq.getTenantUrl(''), tenantUrlPlaceholder) : url;
            },
            file_picker_callback: this.openFileBrowser.bind(this)
        };

        if (this.data.disableParagraphs)
            configuration.forced_root_block = false;

        if (this.data.hasMaxLength) {
            configuration.paste_preprocess = function(plugin, args) {
                var newLength = self.getLengthOfContent() + args.content.length;

                if (newLength > self.data.maxLength)
                    args.content = '';
            };
        }

        if (this.data.stripFormattingOnPaste) {
            configuration.paste_postprocess  = function(plugin, args) {
                var value = args.node.innerHTML;
                if (value && value.match(/\&nbsp;/g)) {
                    args.node.innerHTML = value.replace(/\&nbsp;/g, '');
                }
            };
        }

        tinymce.init(configuration);
    };

    RichTextEditor.prototype.getLengthOfContent = function() {
        return this.editor
            .getContent({ format: 'text' })
            .replace(/(\r\n\t|\n|\r\t)/gm, '')
            .length;
    };

    RichTextEditor.prototype.contentChanged = function () {
        var value = this.editor.getContent();

        if (value === this.lastChange)
            return;

        this.lastChange = value;

        if (this.data.required)
            this.updateRequiredIndicator();

        this.triggerChangedEvent();
    };

    RichTextEditor.prototype.getCssClassNameForStyling = function() {
        var actualStyle = this.data.styles;
        var prefix = 'userstyle-';

        if (!actualStyle) {
            var styleId = Style.getDefaultStyleIdByDropType(this);
            if (styleId) return Style.getClassNameFromStyleId(prefix, styleId);
        } else if (typeof actualStyle === 'string') {
            return Style.getClassNameFromStyleId(prefix, actualStyle);
        }

        return '';
    };

    RichTextEditor.prototype.buildPluginsList = function () {
        var plugins = '';
        if (this.data.insertLinkEnabled)
            plugins += ' link';
        if (this.data.fontForegroundEnabled || this.data.fontBackgroundEnabled)
            plugins += ' textcolor';
        if (this.data.stripFormattingOnPaste || this.data.pasteEnabled)
            plugins += ' paste';
        if (this.data.imagesEnabled)
            plugins += ' image';
        if (this.data.insertListEnabled)
            plugins += ' lists';
        if (this.data.tablesEnabled)
            plugins += ' table';
        if (this.data.fullscreenEnabled)
            plugins += ' fullscreen';
        if (this.data.previewEnabled)
            plugins += ' preview';
        if (this.data.printEnabled)
            plugins += ' print';
        if (this.data.anchorEnabled)
            plugins += ' anchor';
        if (this.data.searchreplaceEnabled)
            plugins += ' searchreplace';
        if (this.data.wordcountEnabled)
            plugins += ' wordcount';

        return plugins;
    };

    RichTextEditor.prototype.buildToolbar = function () {
        var toolbar = '';

        if (this.data.undoRedoEnabled)
            toolbar += ' undo redo';

        if (toolbar)
            toolbar += ' |';

        if (this.data.boldEnabled)
            toolbar += ' bold';
        if (this.data.italicEnabled)
            toolbar += ' italic';
        if (this.data.underlineEnabled)
            toolbar += ' underline';
        if (this.data.strikethroughEnabled)
            toolbar += ' strikethrough';

        if (toolbar)
            toolbar += ' |';

        if (this.data.fontFamilyEnabled)
            toolbar += ' fontselect';
        if (this.data.fontSizeEnabled)
            toolbar += ' fontsizeselect';
        if (this.data.fontForegroundEnabled)
            toolbar += ' forecolor';
        if (this.data.fontBackgroundEnabled)
            toolbar += ' backcolor';

        if (toolbar)
            toolbar += ' |';

        if (this.data.textAlignEnabled)
            toolbar += ' alignleft aligncenter alignright alignjustify';

        if (toolbar)
            toolbar += ' |';

        if (this.data.insertLinkEnabled)
            toolbar += ' link unlink';

        if (toolbar)
            toolbar += ' |';

        if (this.data.insertListEnabled)
            toolbar += ' bullist numlist';

        if (toolbar)
            toolbar += ' |';

        if (this.data.indentationEnabled)
            toolbar += ' outdent indent';

        if (toolbar)
            toolbar += ' |';

        if (this.data.tablesEnabled)
            toolbar += ' table';

        if (toolbar)
            toolbar += ' |';

        if (this.data.imagesEnabled)
            toolbar += ' image';

        if (this.data.formatselectEnabled)
            toolbar += ' formatselect';

        if (this.data.removeformatEnabled)
            toolbar += ' removeformat';

        if (this.data.fullscreenEnabled)
            toolbar += ' fullscreen';

        if (this.data.previewEnabled)
            toolbar += ' preview';

        if (this.data.printEnabled)
            toolbar += ' print';

        if (this.data.anchorEnabled)
            toolbar += ' anchor';

        if (this.data.cutEnabled)
            toolbar += ' cut';

        if (this.data.copyEnabled)
            toolbar += ' copy';

        if (this.data.pasteEnabled)
            toolbar += ' paste';

        if (this.data.selectallEnabled)
            toolbar += ' selectall';

        if (this.data.searchreplaceEnabled)
            toolbar += ' searchreplace';

        if (this.data.superscriptEnabled)
            toolbar += ' superscript';

        if (this.data.subscriptEnabled)
            toolbar += ' subscript';

        if (this.data.lineheightEnabled)
            toolbar += ' lineheight';

        if (this.data.wordcountEnabled)
            toolbar += ' wordcount';

        return toolbar;
    };

    RichTextEditor.prototype.focus = function () {
        if (this.editor) {
            this.editor.focus();
        } else {
            var self = this;
            _.defer(function () {
                self.focus();
            });
        }
    };

    RichTextEditor.prototype.getValue = function () {
        if (!this.editor) return null;
        return this.editor.getContent();
    };

    RichTextEditor.prototype.clearValue = function () {
        if (!this.editor) return;

        this.editor.setContent('');
        this.lastChange = '';
    };

    RichTextEditor.prototype.setValue = function (update) {
        if (this.editor) {
            if (update.value) {
                var regex = new RegExp(tenantUrlPlaceholder, 'g');
                var content = update.value.replace(regex, lq.getTenantUrl(''));
                this.editor.setContent(content);
                this.lastChange = content;
            } else {
                // note Tinymce doesn't handle 'null' very well
                this.editor.setContent('');
                this.lastChange = '';
            }
        } else {
            this.initialUpdate = update;
        }
    };

    RichTextEditor.prototype.hasValue = function () {
        if (!this.editor) return false;
        return $.trim(this.editor.getContent({ format: 'text' })) !== '';
    };

    RichTextEditor.prototype.openFileBrowser = function (cb, value, meta) {
        var self = this;
        var uploader = new Uploader(this.piping)
            .toTenantUrl("DynamicContent/AddPermanentFile")
            .withFileFilter('image/*')
            .onFileUploaded(function (uploadResponse) {
                if (!uploadResponse.success)
                    throw new Error('Upload failed.');

                var imageUrl = lq.getTenantUrl('DynamicContent/File'
                    + '?id=' + encodeURIComponent(uploadResponse.url)
                    + '&filename=' + encodeURIComponent(uploadResponse.filename));

                cb((window.location.origin + (imageUrl.charAt(0) === '/' ? imageUrl : '/' + imageUrl)), { title: uploadResponse.filename});
            })
            .onUploadFinished(function() {
                self.piping.busyIndicator.hide();
            });

        uploader.uploadSingleFile();
    };

    return RichTextEditor;
});
